import { CardData } from "data/types/CardData";


export const CardButton = ({
  cardData,
  onClick,
}: {
  cardData: CardData;
  onClick: (_: any) => void;
}) => {
  return (
    <button
      key={cardData.id}
      style={{
        textAlign: 'left',
        alignItems: 'center',
        width: 144,
        padding: 12,
      }}
      onClick={onClick}
    >
      <img
        src={`cards/${cardData.imageName}`}
        alt={cardData.name}
        style={{
          width: 120,
          maxHeight: 90,
          boxShadow: '0 5px 12px rgba(0, 0, 0, 0.3)',
          marginRight: 10,
          marginBottom: 5,
        }}
      />
      <p
        style={{
          lineHeight: 1.1,
          margin: 0,
          fontSize: 14,
          fontWeight: 'normal',
        }}
      >
        {cardData.name}
      </p>
    </button>
  );
};